import React, { useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '500px',
  width: '95%',
  margin: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: 24,
  padding: '20px',
};


dayjs.extend(isToday);
dayjs.extend(isYesterday);

const TicketConversation = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [message, setMessage] = useState('');
  const bottomRef = useRef(null);

  const handleChange = (value) => {
    setMessage(value);
  };

  // Sort messages by time (oldest to newest)
  const messages = [
    {
      sender: 'Bender Rodriguez',
      time: '2025-04-17T14:00:00',
      message: "Hey again! Did you get my previous message?",
      fromMe: false,
      signature: '- Bender',
      avatar: 'https://i.imgur.com/LxV1Fbn.png',
    },
    {
      sender: 'Bender Rodriguez',
      time: '2025-04-18T09:15:00',
      message:
        "Hey there, meatbag! As the resident robot around here, I gotta ask: what's the dealio with the onboarding project?... And trust me, you don't want that.",
      fromMe: false,
      signature: '- Bender',
      avatar: 'https://i.imgur.com/LxV1Fbn.png',
    },
    {
      sender: 'Me',
      time: '2025-04-18T09:18:00',
      message:
        '"Hey there, Bender my man! It\'s Peter Griffin from Quahog!... Cheers, buddy!"',
      fromMe: true,
      signature: '- PG',
      avatar: 'https://i.imgur.com/ylK3KZC.png',
    },
  ].sort((a, b) => new Date(a.time) - new Date(b.time));

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Track which dates we've shown
  const shownLabels = new Set();

  const getDateLabel = (dateStr) => {
    const date = dayjs(dateStr);
    if (date.isToday()) return 'Today';
    if (date.isYesterday()) return 'Yesterday';
    return date.format('MMMM D, YYYY');
  };

  return (
    <div className="max-w-4xl mx-auto p-4 font-sans">
      {/* Header */}
      <div className="border-bottom pb-10 mb-16 d-flex justify-content-between align-items-center topstkyTC">
        <div className="d-flex align-items-center mb-2">
          <img
            src="https://i.imgur.com/LxV1Fbn.png" // You can use msg.avatar here if it's dynamic
            alt="avatar"
            className="userimgTcon rounded-full me-3"
          />
          <div className=''>
            <h2 className="text-lg fw-semibold mb-0">Bender Rodriguez</h2>
            <p className="text-sm text-gray-600 mb-0">Account Deactivation</p>
          </div>
        </div>
        <div className="text-sm font-semibold mt-2 text-right text-gray-700 d-flex align-items-center gap-10">
          Ticket ID: <span className="text-black fw-bold">#LNT0125</span>  <div className="dropdown">
            <button className="btn btn-outline-neutral-600 not-active px-6 py-6 text-sm rounded-pill" type="button" data-bs-toggle="dropdown" aria-expanded="false">

              <MoreHorizIcon />
            </button>
            <ul className="dropdown-menu" style={{}}>
              <li><a className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900" href="javascript:void(0)">Close</a></li>
              <li><a className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900" href="javascript:void(0)">Resolved </a></li>
            </ul>
          </div>
        </div>
      </div>


      {/* Messages */}
      <div className="space-y-6 overflow-y-auto max-h-[500px]">
        {messages.map((msg, i) => {
          const label = getDateLabel(msg.time);
          const showLabel = !shownLabels.has(label);
          if (showLabel) shownLabels.add(label);

          return (
            <div key={i}>
              {showLabel && (
                <div className="text-center text-gray-600 font-medium my-4 lineleftright"><span>{label}</span></div>
              )}
              <div
                className={`d-flex align-items-start mb-16 ${msg.fromMe ? 'justify-content-end' : 'justify-content-start'
                  }`}
              >
                {!msg.fromMe && (
                  <img
                    src={msg.avatar}
                    alt="avatar"
                    className="userimgTcon rounded-full me-3"
                  />
                )}
                <div className={`custom-right-class ${msg.fromMe ? 'text-right' : 'text-left'}`}>
                  <div className={`text-sm text-gray-500 fw-bold mb-1 ${msg.fromMe ? 'text-end' : 'text-start'}`}>
                    {msg.fromMe ? (
                      <>
                        <span className=' fw-normal'>{dayjs(msg.time).format('h:mm A')}</span> • Me
                      </>

                    ) : (
                      <>
                        {msg.sender}  <span className=' fw-normal'>• {dayjs(msg.time).format('h:mm A')}</span>
                      </>
                    )}
                  </div>
                  <div
                    className={`p-4 rounded-md inline-block max-w-lg ${msg.fromMe ? 'bg-blue-100 text-left' : 'bg-gray-100'
                      }`}
                  >
                    <p>{msg.message}</p>
                    <p className="text-right mt-2 font-medium">{msg.signature}</p>
                  </div>
                </div>
                {msg.fromMe && (
                  <img
                    src={msg.avatar}
                    alt="avatar"
                    className="userimgTcon rounded-full ms-3"
                  />
                )}
              </div>
              {/* Scroll anchor at the end */}
              {i === messages.length - 1 && <div ref={bottomRef}></div>}
            </div>
          );
        })}
      </div>

      {/* Rich Text Editor */}
      <div className="mt-8">
        <ReactQuill
          theme="snow"
          value={message}
          onChange={handleChange}
          placeholder="This is a message in writing..."
          className="bg-white rounded-md ReactQuillTCov"
        />
        <div className="d-flex justify-content-between align-items-center mt-2 ReactQuillTbtn">
          <div className='d-flex gap-10 align-items-center'>
            <button className="me-2 text-sm text-blue-600 font-medium px-16 py-6 rounded-pill clo" onClick={handleOpen}>Close</button>
            <button className="text-sm text-green-600 font-medium px-16 py-6 rounded-pill res">Resolved</button>
          </div>
          <button className="px-4 py-1 rounded-md font-semibold px-16 py-6 rounded-pill rply">
            Reply
          </button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h4" mb={2} sx={{ textAlign: 'center', }}>
            Are you sure you want to close this ticket?
          </Typography>

          <textarea
            id="modal-modal-description"
            placeholder="Write your reason here "
            rows={4}
            className="form-control border border-gray-300 rounded-md p-16 mb-10"
          ></textarea>

          <div className="d-flex justify-content-center align-items-center gap-10 mt-4 gap-2 text-center flex-column">
            <button
              className="bg-red-600 text-white rounded-md w-100 bgcolorsem01"
              onClick={() => {
                // handleCloseTicket or your custom logic here
              }}
            >
              Ticket Close
            </button>
            <button
              className="bg-gray-300 text-gray-700 rounded-md bck0m0m1"
              onClick={handleClose}
            >
              Back
            </button>
          </div>
        </Box>
      </Modal>


    </div>
  );
};

export default TicketConversation;
